<template>
    <div>
        <div class="row">
            <div class=" col-md-5 pb-2">
                <div class="form-group position-relative">
                    <input v-model.trim="keyword" @keyup.enter="addFilter({key: 'keyword', value: keyword})" type="text" class="form-control pr-5" placeholder="Inseratstitel / Inseratsnummer">
                    <font-awesome-icon icon="search" class="search mm-color" @click="addFilter({key: 'keyword', value: keyword})"/>
                </div>
            </div>
            <div class="col-md-2 pb-2">
              <div class="form-group position-relative input-group">
                <input type="button" class="w-100 btn btn-light filter-icon" name="filter" value="Filter" @click="OpenfiltersModal()" />
              </div>
            </div>
            <div class="col-md-5 pb-2 float-right">
              <select v-model="sort_input" class=" form-control">
                <option value="1"> Sortieren: Neueste zuerst </option>
                <option value="2" >Sortieren: Älteste zuerst</option>
                <option value="3" >Sortieren: Zuletzt aktualisiert</option>
              </select>
            </div>
            <input type="hidden" value="umar"/>
            <!--<div class="col-4 col-md-3">
                <button @click="removeFilters" type="button" class="btn btn-block btn-success font-12 nowrap">Alle anzeigen</button>
            </div>-->
        </div>
        <b-modal ref="modal" title="Filter" :size="'xl'" v-if="filters != null">
          <div class="row mb-3" >
            <div class="col-6 col-md-3 mb-1">
                <select v-model="category" class="form-control">
                    <option value="">Kategorie</option>
                    <option v-for="category in filters.categoryList" :key="category.id" :value="category.id">{{category.name}} ({{category.anzahl}})</option>
                </select>
            </div>
            <div class="col-6 col-md-3 mb-1">
                <select v-model="status" class="form-control ">
                    <option value="">Status</option>
                    <option value="pausiert">pausiert</option>
                    <option value="freigeschaltet">freigeschaltet</option>
                </select>
            </div>
            <div class="col-6 col-md-3 mb-1">
                <select v-model="zusatzleistung" class="form-control">
                    <option value="">Zusatzleistung</option>
                    <option value="fotolink">Startseiten-Fotolink</option>
                    <option value="fotokategorie">Kategorie-Fotolink</option>
                    <option value="topinserat">Topinserat</option>
                    <option value="dailypushup">Dailypushup</option>
                    <option value="weeklypushup">Weeklypushup</option>
                    <option value="ohne_zusatzleistung">Ohne Zusatzleistung</option>
                </select>
            </div>
            <div class="col-6 col-md-3 mb-1">
                <select v-model="created_date" class="form-control">
                    <option value="">Einstellungsdatum</option>
                    <option v-for="year in filters.createdDateList" :value="year.jahr">{{year.jahr}}</option>
                </select>
            </div>
          </div>
          <template slot="modal-footer">
                <b-button variant="secondary" @click="removeFilters">Filter löschen</b-button>
                <b-button variant="success" @click="clearModal">Fertig</b-button>
          </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                keyword: '',
                category: '',
                status: '',
                created_date: '',
                zusatzleistung:'',
                filters: null,
                sort_input: '1'
            }
        },
        watch: {
            category: function(val) {
                this.addFilter({key: 'filter_kategorie', value: val});
            },
            zusatzleistung: function(val) {
                this.addFilter({key: 'filter_zusatzleistung', value: val});
            },
            status: function(val) {
                this.addFilter({key: 'filter_status', value: val});
            },
            created_date: function(val) {
                this.addFilter({key: 'filter_einstelldatum', value: val});
            },
            sort_input: function(val) {
                this.addFilter({key: 'filter_sort_input', value: val});
            },

        },
        methods: {
            addFilter(filter , callRedirect = true) {
                this.$store.commit('FILTER_MUTATION', filter);
                if(this.$store.state.lastOpenedPage > 1 && callRedirect == true){
                    this.$router.push({name: 'inserat-uebersicht', params: {page: 1}})
                }
                this.$store.dispatch('OBJECTS', this.$store.state.lastOpenedPage);
            },
            removeFilters() {
                this.keyword         = '';
                this.category        = '';
                this.status          = '';
                this.created_date    = '';
                this.zusatzleistung  ='';
                this.addFilter({key: 'filter_kategorie', value: ''} , false );
                this.addFilter({key: 'filter_zusatzleistung', value: ''}, false);
                this.addFilter({key: 'filter_status', value: ''}, false);
                this.addFilter({key: 'filter_einstelldatum', value: ''}, false);
                this.addFilter({key: 'filter_sort_input', value: '1'}, false);
                this.addFilter({key: 'keyword', value: ''}, false);
            },
            OpenfiltersModal() {
              this.$refs.modal.show();
            },
            clearModal() {
              this.$refs.modal.hide();
            },
        },
        created() {
            this.filters = this.$store.getters.availableFilters;
            this.$store.watch(
                () =>  this.$store.getters.availableFilters,
                (filters) => { this.filters = filters;}
            );
        },
        destroyed() {
          this.removeFilters();
        }
    }
</script>

<style scoped>
.search{
    width: 15px;
    height: 15px;
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
}
.form-control{
  border : 2.3px solid #808080 !important;
  border-radius: 5px !important;
}
.btn-light{
  border : 2.3px solid #808080 !important;
  border-radius: 5px !important;
}
.filter-icon{
    width: 95px;
    text-align: left;
    background-image: url(/img/intern/filter.svg);
    background-repeat: no-repeat;
    background-position: right;
    background-position-x: 95%;
}
</style>
